import { teamEmailAddressSchema } from "@redotech/redo-model/email/domain-verification";
import * as z from "zod/v4";

export const updateCustomDomainEmailSettings = {
  name: "updateCustomDomainEmailSettings" as const,
  input: z.object({
    addresses: z.array(teamEmailAddressSchema.omit({ id: true })).optional(),
    defaultFromAddressId: z.string().nullish(),
    defaultReplyToAddressId: z.string().nullish(),
  }),
  output: z.object({ message: z.string() }),
};
